import { render } from "./CompanyUsers.vue?vue&type=template&id=dd72ffe2"
import script from "./CompanyUsers.vue?vue&type=script&lang=js"
export * from "./CompanyUsers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/steve/Desktop/valet/rspremote/web/app/themes/rspremote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__